import React, { Component } from 'react';
import { Tile } from '../../components';
import Slider from 'react-slick';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/de';

const INITIAL_STATE = {};

const unslickIfLessThanLength = (size, length) =>
  size >= length
    ? 'unslick'
    : { slidesToShow: size, slidesToScroll: Math.min(2, size) };
class Group extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  render() {
    if (this.props.group) {
      const filteredChilds = this.props.group.children.filter((c) => !!c);
      const childLength = filteredChilds.length;
      const settings = {
        dots: false,
        infinite: false,
        centerMode: false,
        className: 'slider',
        nextArrow: <div />,
        prevArrow: <div />,
        responsive: [
          {
            breakpoint: 580,
            settings: unslickIfLessThanLength(1, childLength),
          },
          {
            breakpoint: 830,
            settings: unslickIfLessThanLength(2, childLength),
          },
          {
            breakpoint: 1024,
            settings: unslickIfLessThanLength(4, childLength),
          },
          {
            breakpoint: 1620,
            settings: unslickIfLessThanLength(4, childLength),
          },
          {
            breakpoint: 1900,
            settings: unslickIfLessThanLength(4, childLength),
          },
          {
            breakpoint: 100000,
            settings: unslickIfLessThanLength(4, childLength),
          },
        ],
      };
      return (
        <div style={{ minHeight: 360 }}>
          <div className="col-md-12 col-lg-10 col-sm-12">
            <div style={{ paddingLeft: '5px' }}>
              <Typography variant="h1">{this.props.group.name}</Typography>
              {/* <h1 style={{ color: ThemeColors.primary1Color, fontSize: 14 }}>{this.props.group.name}</h1> */}
            </div>
          </div>
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 tileGroup">
            <Slider {...settings}>
              {filteredChilds.map((checklist, i) => {
                const checklistDueDates = this.props.group.checklistDueDates;
                const checklistRuns = this.props.group.checklistRuns; //needed to access the last runs of the checklists in the bottom of checklists
                if (checklistDueDates) {
                  const dueDate = checklistDueDates.checklistDueDates.find(
                    (c) => c.checklistId === checklist.id
                  );
                  moment.locale('de');
                  var dueDateMoment = moment(dueDate.checklistDueDateTime);
                  /*if (dueDateMoment.isAfter(moment.Now())) {
                    
                  }*/
                  dueDateMoment = dueDateMoment.fromNow();
                } else {
                  dueDateMoment = '';
                }
                if (!this.props.group.checklistRuns) {
                  return (
                    <Tile
                      className={'tile'}
                      key={i}
                      title={checklist.name}
                      checklist={checklist}
                      subtitle={dueDateMoment}
                      isPinned={checklist.isPinned}
                      onClick={() => this.props.onClick(checklist)}
                      imageUrl={checklist.imageUrl}
                      classes={{ subtitleStyle: '' }}
                      progress={checklist.progress}
                      pinOrUnpinContent={this.props.pinOrUnpinContent}
                      onClickShare={(e) => {
                        e.stopPropagation();
                        this.props.onClickShare(checklist);
                      }}
                    />
                  );
                } else {
                  let checklistRun = checklistRuns[i];
                  return (
                    <Tile
                      className={'tile'}
                      key={i}
                      title={checklist.name}
                      checklist={checklist}
                      subtitle={dueDateMoment}
                      isPinned={checklist.isPinned}
                      onClick={() =>
                        this.props.onClick(checklist, checklistRun)
                      }
                      imageUrl={checklist.imageUrl}
                      classes={{ subtitleStyle: '' }}
                      progress={checklist.progress}
                      pinOrUnpinContent={this.props.pinOrUnpinContent}
                      onClickShare={(e) => {
                        e.stopPropagation();
                        this.props.onClickShare(checklist);
                      }}
                    />
                  );
                }
              })}
            </Slider>
            <div
              style={{
                position: 'absolute',
                height: '100%',
                width: 150,
                // background: 'linear-gradient(to right, rgba(255,255,255,0), white)',
                right: 0,
                top: 0,
              }}
            />
          </div>
        </div>
      );
    }
  }
}

const styles = {
  buttonStyle: {
    fontSize: '14px',
    height: 60,
  },
  sideButtonStyle: {
    width: '100%',
    marginBottom: '20px',
    height: 60,
  },
};

export default Group;



// WEBPACK FOOTER //
// ./src/app/main/checklists/group.js